module.exports = __webpack_public_path__ + "img/sql.d0a0c78a.png";